import Image from "next/image"

import type { Image as PrismaImage } from "@prisma/client"
import type { ImageProps } from "next/image"

/**
 * AWS Image
 *
 * Can apply any Thumbor filters except fit in and quality. Pass in array of filters without wrapping /
 * @see https://docs.aws.amazon.com/solutions/latest/serverless-image-handler/thumbor-filters.html
 */

const AwsImage: React.FC<
  Omit<ImageProps, "src"> & {
    image: PrismaImage
    alt: string
    sizes: string
    thumborFilters?: string[]
  }
> = ({ image, alt, sizes, thumborFilters, ...rest }) => {
  return (
    <Image
      loader={({ src, width, quality }) => {
        // calculate height by comparing the current width to the original width
        const height = Math.round((width / image.width) * image.height)
        // use thumbor fit in and quality filters
        const defaultFilters = [
          `fit-in/${width}x${height}`,
          `filters:quality(${quality || 75})`
        ]
        // any passed in filters except fit in and quality
        const newFilters = thumborFilters
          ? thumborFilters.filter(
              f => !f.includes("fit-in") && !f.includes("filters:quality")
            )
          : []
        const filters = [...defaultFilters, ...newFilters]
        return `${process.env.NEXT_PUBLIC_AWS_IMAGE_API}/${filters.join(
          "/"
        )}/${src}`
      }}
      src={image.awsKey}
      alt={alt}
      sizes={sizes}
      placeholder="blur"
      blurDataURL={image.blurDataURL}
      width={image.width}
      height={image.height}
      {...rest}
    />
  )
}

export default AwsImage
